import axios from "axios";

export default class DownloadController {
  static download(url: string): Promise<any> {
    return new Promise((resolve: Function, reject: Function) => {
      axios
        .get(url)
        .then((response: any) => {
          resolve(response.data);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("DLS-Uploader: Was not able to download file @ " + url);
          reject();
        });
    });
  }
}
